(function () {
  function getSectionIdFromMainEl(mainEl) {
    return mainEl.id.replace('RechargeMainSwiper-', '');
  }

  function setActiveThumb(thumbsEl, index) {
    if (!thumbsEl) return;

    const thumbItems = thumbsEl.querySelectorAll('.recharge-thumb-item');
    thumbItems.forEach(function (item, i) {
      item.classList.toggle('is-active', i === index);
      const button = item.querySelector('.thumbnail');
      if (!button) return;

      if (i === index) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });
  }

  function applyRechargeSlideWidths(swiper, attempt) {
    if (!swiper || !swiper.slides || !swiper.slides.length) return;

    attempt = attempt || 0;
    swiper.update();

    const slideWidth = swiper.width;
    if (!slideWidth && attempt < 30) {
      window.requestAnimationFrame(function () {
        applyRechargeSlideWidths(swiper, attempt + 1);
      });
      return;
    }

    if (!slideWidth) return;

    const spaceBetween = swiper.params.spaceBetween || 0;

    setTimeout(() => {
      [...swiper.slides].forEach((slide, index) => {
        slide.style.setProperty('width', slideWidth + 'px', 'important');
        slide.style.setProperty('max-width', slideWidth + 'px', 'important');
        slide.style.setProperty(
          'margin-right',
          index === swiper.slides.length - 1 ? '0px' : spaceBetween + 'px',
          'important'
        );
        slide.style.setProperty('flex-shrink', '0', 'important');
        slide.style.setProperty('display', 'block', 'important');
      });
    }, 100);

    swiper.update();
  }

  function bindGalleryInteractions(root, mainEl, sectionId) {
    if (root.dataset.rechargeClickBound === 'true') return;
    root.dataset.rechargeClickBound = 'true';

    root.addEventListener('click', function (event) {
      const swiper = mainEl.swiper;
      if (!swiper) return;

      const prevBtn = event.target.closest('.recharge-main-prev-' + sectionId);
      const nextBtn = event.target.closest('.recharge-main-next-' + sectionId);
      const thumbItem = event.target.closest('.recharge-thumb-item');

      // if (prevBtn) {
      //   event.preventDefault();
      //   event.stopPropagation();
      //   swiper.slidePrev();
      //   return;
      // }

      // if (nextBtn) {
      //   event.preventDefault();
      //   event.stopPropagation();
      //   swiper.slideNext();
      //   return;
      // }

      if (thumbItem) {
        event.preventDefault();
        const index = parseInt(thumbItem.dataset.thumbIndex, 10);
        if (Number.isNaN(index)) return;
        swiper.slideTo(index);
        const thumbsEl = document.querySelector('#RechargeThumbsSwiper-' + sectionId);
        setActiveThumb(thumbsEl, index);
      }
    });
  }

  function initRechargeGallery(mainEl) {
    if (!mainEl || typeof Swiper === 'undefined') return false;

    const sectionId = getSectionIdFromMainEl(mainEl);
    const root = mainEl.closest('.recharge-thumbnail-carousel');
    const thumbsEl = document.querySelector('#RechargeThumbsSwiper-' + sectionId);
    const prevBtn = mainEl.querySelector('.recharge-main-prev-' + sectionId);
    const nextBtn = mainEl.querySelector('.recharge-main-next-' + sectionId);

    if (mainEl.swiper) {
      mainEl.swiper.destroy(true, true);
    }

    const mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 30,
      speed: 400,
      preloadImages: true,
      updateOnImagesReady: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: 'swiper-button-disabled'
      },
      on: {
        init: function () {
          applyRechargeSlideWidths(this);
          setActiveThumb(thumbsEl, this.activeIndex);
        },
        resize: function () {
          applyRechargeSlideWidths(this);
        },
        slideChange: function () {
          setActiveThumb(thumbsEl, this.activeIndex);
        }
      }
    });

    if (root) {
      bindGalleryInteractions(root, mainEl, sectionId);
    }

    if (!mainEl.dataset.rechargeResizeBound) {
      mainEl.dataset.rechargeResizeBound = 'true';
      window.addEventListener('resize', function () {
        if (mainEl.swiper) {
          applyRechargeSlideWidths(mainEl.swiper);
        }
      });
    }

    window.requestAnimationFrame(function () {
      applyRechargeSlideWidths(mainSwiper);
    });

    return true;
  }

  function initAllRechargeGalleries() {
    const galleries = document.querySelectorAll('.recharge-main-swiper:not(.swiper-container-initialized)');
    if (!galleries.length) return;

    if (typeof Swiper === 'undefined') {
      window.setTimeout(initAllRechargeGalleries, 50);
      return;
    }

    galleries.forEach(function (mainEl) {
      initRechargeGallery(mainEl);
    });
  }

  function reinitAllRechargeGalleries() {
    document.querySelectorAll('.recharge-main-swiper').forEach(function (mainEl) {
      if (mainEl.swiper) {
        mainEl.swiper.destroy(true, true);
      }
      initRechargeGallery(mainEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllRechargeGalleries);
  } else {
    initAllRechargeGalleries();
  }

  window.addEventListener('load', initAllRechargeGalleries);

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(reinitAllRechargeGalleries, 100);
  });
})();


  var swiper = new Swiper('.mySwiper-related_product', {
    pagination: {
      el: '.swiper-pagination',
    },
  });